export default "__VITE_ASSET__aXC_peW$__"